import React from 'react';
import { leadershipMandate } from '../data/corporateData';
import { Target, Shield, Settings } from 'lucide-react';

const iconMap = {
  'strategic-vision': Target,
  'risk-mitigation': Shield,
  'scalable-ops': Settings
};

const LeadershipMandate = () => {
  return (
    <section className="py-16 sm:py-24 bg-[#0F172A]" id="mandate">
      <div className="container mx-auto px-4 sm:px-8 lg:px-16">
        <div className="max-w-5xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12">
            <span className="text-xs font-bold tracking-[0.2em] uppercase text-rose-500 font-heading mb-4 block">
              Executive Philosophy
            </span>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white mb-4 font-heading">
              {leadershipMandate.title}
            </h2>
            <p className="text-lg text-slate-300 leading-relaxed font-body max-w-3xl mx-auto">
              {leadershipMandate.vision}
            </p>
          </div>

          {/* Principles Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-testid="leadership-principles">
            {leadershipMandate.principles.map((principle) => {
              const IconComponent = iconMap[principle.id] || iconMap['strategic-vision'];
              return (
                <div
                  key={principle.id}
                  className="bg-[#112240] border border-white/10 rounded-lg p-6 hover:border-rose-500/50 transition-all duration-300 text-center"
                  data-testid={`principle-${principle.id}`}
                >
                  <div className="w-14 h-14 bg-rose-500/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                    <IconComponent className="text-rose-500" size={28} />
                  </div>
                  <h3 className="text-lg font-semibold text-white mb-3 font-heading">
                    {principle.title}
                  </h3>
                  <p className="text-sm text-slate-300 leading-relaxed font-body">
                    {principle.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeadershipMandate;
